import { render, staticRenderFns } from "./DepositExternal.vue?vue&type=template&id=f2e6c65a"
import script from "./DepositExternal.vue?vue&type=script&lang=js"
export * from "./DepositExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports